import { render, staticRenderFns } from "./ModalSms.vue?vue&type=template&id=cf0f8ce4&"
import script from "./ModalSms.vue?vue&type=script&lang=js&"
export * from "./ModalSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports